/**
 * Unified MitWellness button CTA handler.
 *
 * Buttons rendered by snippets/mw-button.liquid with the "Use onclick event"
 * option enabled emit [data-mw-cta] and are handled here: a CustomEvent is
 * dispatched, the click is pushed to the GTM dataLayer, then the target is
 * navigated to via JavaScript (event only, no navigation, when no target).
 */
(function () {
  if (window.__mwButtonCtaBound) return;
  window.__mwButtonCtaBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mw-cta]');
    if (!button) return;

    var target = button.getAttribute('data-mw-cta-target') || '';
    var eventName = button.getAttribute('data-mw-cta-event') || 'mw-button:cta-click';
    var opensNewWindow = button.getAttribute('data-mw-cta-new-window') === 'true';

    var sectionHost = button.closest('[data-mw-cta-section-id]');
    var sectionId = sectionHost ? sectionHost.getAttribute('data-mw-cta-section-id') : '';
    if (!sectionId) {
      var shopifySection = button.closest('.shopify-section');
      sectionId = shopifySection && shopifySection.id ? shopifySection.id : '';
    }

    var detail = {
      target: target,
      label: (button.textContent || '').trim(),
      sectionId: sectionId
    };

    button.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: detail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: eventName,
        locationActionTarget: detail.target,
        locationActionLabel: detail.label,
        locationActionSectionId: detail.sectionId
      });
    }

    if (!target) return;

    if (/^tel:/i.test(target)) {
      window.location.href = target;
    } else if (opensNewWindow) {
      window.open(target, '_blank', 'noopener');
    } else {
      window.location.assign(target);
    }
  });
})();
